/*
Fork addition: lightweight selection state for the right-hand inspector
panel. Deliberately separate from usePointAndClick (that system is the
touch-oriented place/move mode and only exists when pointAndClickEnabled).
Selection is by item key, so a stale selection simply resolves to
"nothing selected" once the item is deleted.

Two mutually exclusive things can fill the inspector:
- a board selection (a placed BlueprintItemModel, by key), and
- a left-panel preview (a GameItem, by name) shown when a factory entry
  is clicked in the toolbox. Selecting one clears the other.
*/
import {createSharedComposable} from '@vueuse/core';
import {readonly, ref} from 'vue';

export const useInspectorSelection = createSharedComposable(() => {
    const selectedItemKey = ref<string | undefined>();
    const previewItemName = ref<string | undefined>();

    function selectItem(key: string | undefined) {
        selectedItemKey.value = key;
        if(key !== undefined)
            previewItemName.value = undefined;
    }
    function setPreview(name: string | undefined) {
        previewItemName.value = name;
        if(name !== undefined)
            selectedItemKey.value = undefined;
    }
    function clearSelection() {
        selectedItemKey.value = undefined;
        previewItemName.value = undefined;
    }

    return {
        selectedItemKey: readonly(selectedItemKey),
        previewItemName: readonly(previewItemName),
        selectItem,
        setPreview,
        clearSelection,
    };
});
